export default [
  {
    name: 'Profile.Edit',
    path: 'edit',
    component: () => import('./components/Edit')
  },
  {
    name: 'Profile.ChangePassword',
    path: 'change-password',
    component: () => import('./components/ChangePassword')
  }
]
